"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSearchLand = void 0;

var _react = require("react");

var _apiContext = require("../../../context/apiContext");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useSearchLand = function useSearchLand(_ref) {
  var newTabRef = _ref.newTabRef;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      params = _useState2[0],
      setParams = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var api = (0, _apiContext.useGetApiClient)();
  (0, _react.useEffect)(function () {
    if (params === undefined) {
      return;
    }

    setLoading(true);
    api === null || api === void 0 ? void 0 : api.getSearchLand(params).then(function (response) {
      if (!response) {
        return;
      }

      var redirect_url = response.redirect_url;
      var windowRef = newTabRef || window;
      windowRef.location.href = redirect_url;
    })["finally"](function () {
      setLoading(false);
    });
  }, [api, newTabRef, params]);
  return {
    setParams: setParams,
    loading: loading
  };
};

exports.useSearchLand = useSearchLand;